// Renders a miniature bingo grid illustrating a win pattern.
// Used in GameSetupPage (pattern selector) and BingoCardPage (student guide).

// Returns the highlighted cell indices for a given pattern and board size.
// For 'line', returns a representative first row for illustration purposes.
export function getPatternCells(pattern, size) {
  if (pattern === 'line') {
    return new Set(size === 5 ? [0,1,2,3,4] : [0,1,2,3]);
  }
  const cells = (() => {
    if (size === 5) {
      switch (pattern) {
        case 'blackout':      return Array.from({ length: 25 }, (_, i) => i);
        case 'four_corners':  return [0, 4, 20, 24];
        case 'x':             return [0, 4, 6, 8, 12, 16, 18, 20, 24];
        case 'plus':          return [2, 7, 10, 11, 12, 13, 14, 17, 22];
        case 't':             return [0, 1, 2, 3, 4, 7, 12, 17, 22];
        case 'l':             return [0, 5, 10, 15, 20, 21, 22, 23, 24];
        case 'frame':         return [0,1,2,3,4,5,9,10,14,15,19,20,21,22,23,24];
        default:              return [];
      }
    } else {
      switch (pattern) {
        case 'blackout':      return Array.from({ length: 16 }, (_, i) => i);
        case 'four_corners':  return [0, 3, 12, 15];
        case 'x':             return [0, 3, 5, 6, 9, 10, 12, 15];
        case 'l':             return [0, 4, 8, 12, 13, 14, 15];
        case 'frame':         return [0,1,2,3,4,7,8,11,12,13,14,15];
        default:              return [];
      }
    }
  })();
  return new Set(cells);
}

export default function PatternPreview({ pattern, size = 5, freeSpace = true, cellSize = 12 }) {
  const highlighted = getPatternCells(pattern, size);
  const freeIdx = size === 5 && freeSpace ? 12 : -1;
  const gap = 2;

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: `repeat(${size}, ${cellSize}px)`,
      gap: `${gap}px`,
      flexShrink: 0,
    }}>
      {Array.from({ length: size * size }, (_, idx) => {
        const isFree = idx === freeIdx;
        const isHighlighted = highlighted.has(idx);
        return (
          <div key={idx} style={{
            width: cellSize,
            height: cellSize,
            borderRadius: 2,
            backgroundColor: isFree
              ? 'var(--color-accent)'
              : isHighlighted
              ? 'var(--color-primary)'
              : 'color-mix(in srgb, var(--color-surface) 30%, var(--color-background))',
          }} />
        );
      })}
    </div>
  );
}
